<template>
  <v-row no-gutters>
    <feature-card-basic :layer="layer" @update:feature="onFeatureUpdate">
      <template #top v-if="widgetVisible">
        <feature-joins :layer-id="layerId" :feature-id="currentFeatureId" :values="values" />
      </template>
    </feature-card-basic>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';
import FeatureCardBasic from '@/components/FeatureCardBasic';
import FeatureJoins from '@/components/FeatureJoins';
export default {
  name: 'FeatureCardJoins',
  components: { FeatureCardBasic, FeatureJoins },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dataSources: get('layers/metadata'),
    layers: get('layers/layers'),
    dataSourceIdAttributeName() {
      return this.dataSources[this.layers[this.layerId].data_source_name]?.attributes_schema.id_name;
    },
    isAdminEnabled: get('admin/settingsValues@joins_module_enabled'),
    isSuperAdminEnabled: get('admin/additionalModules@JOINS.enabled'),
    modulesPermissions: get('users/toolsPermissions@JOINS'),
    currentFeatureId() {
      return +this.$route.params.fid;
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    layerId() {
      return +this.layer?.id || null;
    },
    permissions() {
      const value = this.modulesPermissions.main_value;
      return value > 0;
    },
    widgetVisible() {
      return this.isSuperAdminEnabled && this.isAdminEnabled && !this.isNew && this.permissions;
    },
  },
  data: () => ({
    values: {},
  }),
  methods: {
    onFeatureUpdate(feature) {
      this.values = { ...feature.properties, [this.dataSourceIdAttributeName]: this.currentFeatureId };
    },
  },
};
</script>
